import { getColorStyles } from 'utils/colorStyles';

export const getIconBackground = ({ resolvedColor, variant }) => {
  if (!resolvedColor) {
    return {};
  }

  const styles = getColorStyles({ resolvedColor, variant });

  if (variant === 'contained') {
    return {
      backgroundColor: styles.backgroundColor,
      color: styles.color,
    };
  }

  return {
    backgroundColor: `${resolvedColor.bg}`,
    color: resolvedColor.fg,
  };
};

export const getAccentBorderSx = resolvedColor => {
  if (!resolvedColor) {
    return {};
  }

  return { borderLeftColor: resolvedColor.dot || resolvedColor.fg };
};
